import { jsPDF as JSPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { sToHMSColonSeparated } from '../../helpers';

const ViewTimecardPDF = (timesheetDetails) => {
  // initialize jsPDF
  const doc = new JSPDF('l', 'pt', 'a4');
  const totalPagesExp = '{total_pages_count_string}';
  const pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  const approvalTableColumns = {
    0: {
      halign: 'left',
    },
    1: {
      halign: 'center',
    },
    2: {
      halign: 'center',
    },
    3: {
      halign: 'center',
    },
    4: {
      halign: 'center',
    },
  };

  const weeklyStatus = (status) => {
    switch (status) {
      case 'submit':
        return 'Submitted';
      case 'approve':
        return 'Approved';
      case 'reject':
        return 'Rejected';
      case 'withdraw':
        return 'Withdrawn';
      default:
        return 'Not Submitted';
    }
  };

  timesheetDetails.forEach((weekData) => {
    doc.setFontSize(10);
    if (weekData.user) {
      doc.text(
        `Employee : ${weekData.user.firstName} ${weekData.user.lastName}`,
        40,
        doc.lastAutoTable ? doc.lastAutoTable.finalY + 45 : 45,
        'left'
      );
    }
    doc.text(
      `Period : ${moment
        .utc(weekData.wsWeekDetails.startDate)
        .format('MMM DD, YYYY')} - ${moment
        .utc(weekData.wsWeekDetails.endDate)
        .format('MMM DD, YYYY')}`,
      40,
      doc.lastAutoTable ? doc.lastAutoTable.finalY + 60 : 60,
      'left'
    );
    doc.text(
      `Status : ${weeklyStatus(weekData.status)}`,
      800,
      doc.lastAutoTable ? doc.lastAutoTable.finalY + 60 : 60,
      'right'
    );

    // Table header columns
    const tableColumn = ['', 'Clock In', 'Clock Out', 'Breaks', 'Total'];

    // Table body columns
    const tableRows = [];

    // for each worksession pass all its data into an array
    weekData.data.forEach((day) => {
      const worksessionData = [
        moment(day.date).format('ddd, MMM DD'),
        day.clockIn ? moment(day.clockIn).format('hh:mm A') : '-',
        day.clockOut ? moment(day.clockOut).format('hh:mm A') : '-',
        day.totalBreakTimeSeconds > 0
          ? sToHMSColonSeparated(day.totalBreakTimeSeconds, 'hh:mm')
          : '00:00',
        day.totalWorkSessionSeconds > 0
          ? sToHMSColonSeparated(day.totalWorkSessionSeconds, 'hh:mm')
          : '00:00',
      ];

      // push each session's info into a row
      tableRows.push(worksessionData);
    });

    // Initialize autoTable
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      // foot: [tableFoot],
      startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 75 : 75,
      theme: 'grid',
      styles: { cellPadding: 10 },
      headStyles: {
        fillColor: [237, 242, 249],
        // fontSize: 9,
        textColor: [40, 62, 89],
        halign: 'center',
      },
      columnStyles: approvalTableColumns,
      footStyles: {
        fillColor: [237, 242, 249],
        textColor: [40, 62, 89],
      },
      tableLineColor: [237, 242, 249],
      tableLineWidth: 1,
      showFoot: 'lastPage',
      didDrawPage() {
        // Header
        doc.setFontSize(14);
        doc.setTextColor(40);
        doc.text('Timecard', pageWidth / 2, 23, 'center');
        doc.setFontSize(10);
        // Footer
        let str = `Page ${doc.internal.getNumberOfPages()}`;
        // Total page number
        if (typeof doc.putTotalPages === 'function') {
          str = `${str} of ${totalPagesExp}`;
        }
        doc.setFontSize(10);
        const { pageSize } = doc.internal;
        const pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, 750, pageHeight - 22);
      },
    });
  });

  // Total page number
  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  // Name of PDF file.
  doc.save(`timecard_report.pdf`);
};

export default ViewTimecardPDF;
